module.exports = __webpack_public_path__ + "img/course7.28870a87.png";